// extracted by mini-css-extract-plugin
export default {"refWrapper":"yai5ijU","iconWrapper":"GFY92ul","loader":"m7VhVtz","rotate":"QAeoqZf","loaderText":"QH0kKnS"};